"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.getVh = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = require("styled-components");

var screenSizes_1 = require("./screenSizes");

function updateVh() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + "px");
}

if (typeof window !== 'undefined') {
  updateVh();
  window.addEventListener('resize', function () {
    updateVh();
  });
}

function getVh(vh) {
  if (typeof window === 'undefined') {
    return vh + "vh";
  }

  return "calc(var(--vh, 1vh) * " + vh + ")";
}

exports.getVh = getVh;
exports.media = Object.keys(screenSizes_1.BREAK_POINTS).reduce(function (mediaCollector, size) {
  mediaCollector[size] = function () {
    var args = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }

    return styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n\t\t\t@media (max-width: ", "px) {\n\t\t\t\t", ";\n\t\t\t}\n\t\t"], ["\n\t\t\t@media (max-width: ", "px) {\n\t\t\t\t", ";\n\t\t\t}\n\t\t"])), screenSizes_1.BREAK_POINTS[size], styled_components_1.css.call.apply(styled_components_1.css, tslib_1.__spreadArrays([undefined], args)));
  };

  return mediaCollector;
}, {});
var templateObject_1;